import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import AdminOnly from "../../../../components/AdminOnly";
import CustomeButton from "../../../../components/Button/index";
import ToastMessage from "~/components/ToastMessage";
import BankInformationForm from "./BankInformationForm";
import useEditBankInformation from "../../actions/useEditBankInformation";
import ErrorMessage from "~/components/Processes/conversations/ErrorMessage";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes-v2";

const EditBankInfo = () => {
  const { id } = useParams();
  const {
    onChangeBankInformation,
    bankData,
    toastRef,
    handleEnableEdit,
    handleDiscardEdit,
    setShowError,
    handleUpdate,
    setAuditSidebarVisible,
    states,
  } = useEditBankInformation();
  const auditLabels = () => ({
    update: "Bank Information Updated",
    create: `Bank Information Added`,
    delete: `Bank Information Deleted`,
  });
  return (
    <>
      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4 align-items-center">
          <div className="">
            <p className="heading m-0 mb-2">Bank Information</p>
            <p className="description m-0">
              Find employee banking information here to facilitate accurate and
              timely payroll projects.
            </p>
          </div>
          <AdminOnly>
            <div className="flex gap-1">
              {states.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    label={"Save Changes"}
                    variant="contained"
                    onClick={handleUpdate}
                    loading={states?.isUpdating}
                    disabled={states?.isUpdating || states?.isSaveBtn}
                    className={`mr-2 access-btn  ${states?.isSaveBtn && "disable"}`}
                    iconPos="right"
                  />
                </>
              ) : (
                <>
                  <Button
                    className="edit-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </Button>
                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </AdminOnly>
        </div>
        <div className="formgrid grid">
          <BankInformationForm
            bankInformation={bankData}
            handleChange={onChangeBankInformation}
            isLoading={states.loading}
            isEdit={states.isEdit}
          />
        </div>
        <ToastMessage ref={toastRef} />
        {states.isAuditSidebarVisible && (
          <AuditSidebar
            heading="Bank Information"
            endpoint={API_ROUTES.FETCH_EMPLOYEE_AUDIT}
            id={id}
            objectType="BANK_INFORMATION"
            labels={auditLabels}
            setSidebarToggle={setAuditSidebarVisible}
            sidebarToggle={states.isAuditSidebarVisible}
          />
        )}
        <div className="error__message">
          {states.isError && (
            <ErrorMessage
              summary={
                "Something went wrong while saving employment information."
              }
              detail="Please check the fields and try again."
              handleClose={() => {
                setShowError(false);
              }}
            />
          )}
        </div>
      </Card>
    </>
  );
};

export default EditBankInfo;
